import { AUTOMATIONS_TABS, baseRoutes, REPORTING_TABS } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route';

export const studioRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.studio.root,
    lazyImport: () => import('../../domains/protected/studio/StudioRoute.tsx'),
    requiresAuth: true,
    resourceId: 'form',
    children: [
      {
        index: true,
        redirectTo: routesPaths.studio.forms.root
      },
      {
        path: baseRoutes.studio.forms.root,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/forms/forms-list/FormsDataGrid.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.studio.formGroups.root,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/form-groups/form-groups-list/FormGroupsDataGrid.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.studio.expressions.root,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/expressions/expressions-list/ExpressionsListRoute.tsx'),
        resourceId: 'expression',
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.studio.automations.root,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/automations/AutomationsRoute.tsx'),
        children: [
          {
            index: true,
            redirectTo: routesPaths.studio.automations.workflows
          },
          {
            path: AUTOMATIONS_TABS.workflows,
            lazyImport: () =>
              import('../../domains/protected/studio/pages/automations/workflow/workflows-list/WorkflowsListRoute.tsx'),
            resourceId: 'workflow',
            nav: {
              hideBack: true,
              breadcrumbKey: 'list'
            }
          },
          {
            path: AUTOMATIONS_TABS.logs,
            lazyImport: () =>
              import('../../domains/protected/studio/pages/automations/logs/logs-list/LogsListRoute.tsx'),
            resourceId: 'workflow',
            nav: {
              hideBack: true,
              breadcrumbKey: 'list'
            }
          }
        ]
      },
      {
        path: baseRoutes.studio.taxonomies.root,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/taxonomies/TaxonomiesRoute.tsx'),
        children: [
          {
            index: true,
            redirectTo: routesPaths.studio.taxonomies.tags
          },
          {
            path: 'tags',
            lazyImport: () =>
              import('../../domains/protected/studio/pages/taxonomies/TagsListRoute.tsx'),
            resourceId: 'form',
            nav: {
              hideBack: true,
              breadcrumbKey: 'list'
            }
          },
          {
            path: 'categories',
            lazyImport: () =>
              import('../../domains/protected/studio/pages/taxonomies/CategoriesListRoute.tsx'),
            resourceId: 'form',
            nav: {
              hideBack: true,
              breadcrumbKey: 'list'
            }
          }
        ]
      },
      {
        path: baseRoutes.studio.reporting.root,
        lazyImport: () => import('../../domains/protected/studio/pages/reports/ReportingRoute.tsx'),
        children: [
          {
            index: true,
            redirectTo: routesPaths.studio.reporting.reports
          },
          {
            path: REPORTING_TABS.reports,
            lazyImport: () =>
              import('../../domains/protected/studio/pages/reports/reports/reports-list/ReportsDatagrid.tsx'),
            nav: {
              hideBack: true,
              breadcrumbKey: 'list'
            }
          },
          {
            path: REPORTING_TABS.textwidgets,
            lazyImport: () =>
              import('../../domains/protected/studio/pages/reports/txt-widgets/txt-widgets-list/TextWidgetsDataGrid.tsx'),
            nav: {
              hideBack: true,
              breadcrumbKey: 'list'
            }
          }
        ]
      },
      {
        path: baseRoutes.studio.forms.creator,
        lazyImport: () =>
          import('../../domains/protected/studio/shared/creator/FormCreatorRoute.tsx'),
        nav: {
          backTo: routesPaths.studio.forms.root,
          breadcrumbKey: 'creator'
        }
      },
      {
        path: baseRoutes.studio.forms.details,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/forms/form-editor/FormDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.studio.forms.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.studio.formGroups.details,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/form-groups/form-group-editor/FormGroupDetailsRoute.tsx'),
        resourceId: 'form-group',
        nav: {
          backTo: routesPaths.studio.formGroups.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.studio.reporting.reportDetails,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/reports/reports/report-editor/ReportDetailsRoute.tsx'),
        resourceId: 'report',
        nav: {
          backTo: routesPaths.studio.reporting.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.studio.reporting.newTextWidget,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/reports/txt-widgets/txt-widget-editor/TextWidgetDetailsRoute.tsx'),
        resourceId: 'report',
        nav: {
          backTo: routesPaths.studio.reporting.root,
          backToSearch: {
            tab: routesPaths.studio.reporting.textwidgets
          },
          breadcrumbKey: 'newTextWidget'
        }
      },
      {
        path: baseRoutes.studio.reporting.textwidgetDetails,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/reports/txt-widgets/txt-widget-editor/TextWidgetDetailsRoute.tsx'),
        resourceId: 'report',
        nav: {
          backTo: routesPaths.studio.reporting.root,
          backToSearch: {
            tab: routesPaths.studio.reporting.textwidgets
          },
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.studio.reporting.reportDesigner,
        lazyImport: () =>
          import('../../domains/protected/studio/shared/creator/FormCreatorRoute.tsx'),
        resourceId: 'report',
        nav: {
          backTo: routesPaths.studio.reporting.reportDesigner(':id'),
          breadcrumbKey: 'creator'
        }
      },
      {
        path: baseRoutes.studio.expressions.new,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/expressions/expression-editor/ExpressionDetailsRoute.tsx'),
        resourceId: 'expression',
        nav: {
          backTo: routesPaths.studio.expressions.root,
          breadcrumbKey: 'new'
        }
      },
      {
        path: baseRoutes.studio.expressions.details,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/expressions/expression-editor/ExpressionDetailsRoute.tsx'),
        resourceId: 'expression',
        nav: {
          backTo: routesPaths.studio.expressions.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.studio.automations.newWorkflow,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/automations/workflow/workflow-editor/WorkflowDetailsRoute.tsx'),
        resourceId: 'workflow',
        nav: {
          backTo: routesPaths.studio.automations.workflows,
          breadcrumbKey: 'newWorkflow'
        }
      },
      {
        path: baseRoutes.studio.automations.workflowDetails,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/automations/workflow/workflow-editor/WorkflowDetailsRoute.tsx'),
        resourceId: 'workflow',
        nav: {
          backTo: routesPaths.studio.automations.workflows,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.studio.automations.logDetails,
        lazyImport: () =>
          import('../../domains/protected/studio/pages/automations/logs/log-details/LogViewer.tsx'),
        resourceId: 'workflow',
        nav: {
          backTo: routesPaths.studio.automations.logs,
          breadcrumbKey: 'details'
        }
      },
      {
        path: '*',
        redirectTo: baseRoutes.studio.forms.root
      }
    ]
  }
];
